import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { DEFAULT_LAYOUT_ID } from '../tokens';
import { DEFAULT_MONITORING_LAYOUT } from './DefaultMonitoring';

export const DEFAULT_MONITORING_LAYOUT_SPEC: LayoutSpec = {
  templateId: DEFAULT_LAYOUT_ID,
  label: 'Monitoring Blotter',
  id: DEFAULT_LAYOUT_ID,
  dockViewLayout: DEFAULT_MONITORING_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
